@if (label) {
  <ion-label class="otp__label">{{ label }}</ion-label>
}

<ng-otp-input class="otp__field" [config]="config" [formControl]="control"></ng-otp-input>
